import { Controller, useFormContext } from 'react-hook-form';

import * as S from '../styles';
import { FieldRendererProps } from '../types';

const RadioField = ({ field, disabled }: FieldRendererProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={field.name}
      control={control}
      defaultValue={field.default_value || ''}
      render={({ field: formField }) => (
        <S.RadioGroup>
          {field.options?.map((option) => (
            <S.RadioLabel key={option.value} $disabled={disabled}>
              <input
                type="radio"
                {...formField}
                value={option.value}
                checked={formField.value === option.value}
                disabled={disabled}
              />
              <span>{option.label}</span>
            </S.RadioLabel>
          ))}
        </S.RadioGroup>
      )}
    />
  );
};

export default RadioField;
